import { render, staticRenderFns } from "./BoxSection.vue?vue&type=template&id=96dc77ba&"
import script from "./BoxSection.vue?vue&type=script&lang=js&"
export * from "./BoxSection.vue?vue&type=script&lang=js&"
import style0 from "./BoxSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports